'use strict';

const delay = async (ms) => new Promise(resolve => globalThis.setTimeout(resolve, ms));

exports.delay = delay;
//# sourceMappingURL=timers.js.map
